const KEY = 'chunk-recovery-at';
const COOLDOWN_MS = 60_000;

export function isChunkLoadError(error) {
  return error?.name === 'ChunkLoadError' ||
    /Loading (?:CSS )?chunk .+ failed|ChunkLoadError|Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module/i.test(error?.message || '');
}

export function recoverChunk(error, browser = typeof window === 'undefined' ? undefined : window) {
  if (!browser || !isChunkLoadError(error) || browser.navigator?.onLine === false) return false;
  try {
    const previous = Number(browser.sessionStorage.getItem(KEY));
    const now = Date.now();
    if (previous && now - previous < COOLDOWN_MS) return false;
    browser.sessionStorage.setItem(KEY, String(now));
    // Without persistent storage, a failed bundle could reload forever.
    if (browser.sessionStorage.getItem(KEY) !== String(now)) return false;
    browser.location.reload();
    return true;
  } catch {
    return false;
  }
}

export function installChunkRecovery(browser) {
  browser.addEventListener('vite:preloadError', (event) => {
    if (recoverChunk(event.payload, browser)) event.preventDefault();
  });
  browser.addEventListener('unhandledrejection', (event) => {
    if (recoverChunk(event.reason, browser)) event.preventDefault();
  });
}
